import { AuthActions, ERD } from "@dots-crm/contracts/client";
import { api } from "api";
import { QueryArgsNew } from "api/api.type";
import { AUTH_ENDPOINTS_URLS } from "./api-auth.constant";
import { PhoneExistsCheck, ValidateRefIdResult } from "./api-auth.type";

export const {
  useRegisterMutation,
  useLoginMutation,
  useCheckPhoneExistsMutation,
  useValidateRefIdMutation,
} = api.injectEndpoints({
  endpoints: (builder) => ({
    register: builder.mutation<
      ERD<AuthActions["register"]>,
      QueryArgsNew<AuthActions["register"]>
    >({
      query: ({ payload }) => ({
        url: AUTH_ENDPOINTS_URLS.register,
        method: "post",
        payload,
      }),
    }),
    login: builder.mutation<
      ERD<AuthActions["login"]>,
      QueryArgsNew<AuthActions["login"]>
    >({
      query: ({ payload }) => ({
        url: AUTH_ENDPOINTS_URLS.login,
        method: "post",
        payload,
      }),
    }),
    checkPhoneExists: builder.mutation<
      PhoneExistsCheck,
      QueryArgsNew<AuthActions["checkPhoneExists"]>
    >({
      query: ({ payload }) => ({
        url: AUTH_ENDPOINTS_URLS.checkPhoneExists,
        method: "post",
        payload,
      }),
    }),
    validateRefId: builder.mutation<
      ValidateRefIdResult,
      QueryArgsNew<AuthActions["validateRefId"]>
    >({
      query: ({ payload }) => ({
        url: AUTH_ENDPOINTS_URLS.validateRefId,
        method: "post",
        payload,
      }),
    }),
  }),
});
